import { useUserStore } from "base/stores";
import {
  formatDateTime,
  formatDateToUserDate,
  getDayjsObject
} from "base/utils";

import { DateClass, DateTimeClass } from "./fieldclass";

function dueDateOverDue(dueDate) {
  const { currentUser } = useUserStore.getState();
  const dayJsObj = getDayjsObject(dueDate).tz(currentUser.TimeZone._id);
  const currentDate = getDayjsObject().tz(currentUser.TimeZone._id);
  const secDiff = dayJsObj.diff(currentDate, "second");
  return secDiff / 3600 < -24;
}

export function resolveRelativeValue(key, type, data) {
  if (type === "User" || type === "MultiUser") {
    if (key === "_current_user") {
      let { _id, Name } = useUserStore.getState().currentUser;
      return { _id, Name };
    } else {
      return data[key];
    }
  }
  return null;
}

export const VALID_DATE_RELATIVE_VALUES = new Set([
  "Now",
  "Next6Hours",
  "Next12Hours",
  "Today",
  "Tomorrow",
  "Yesterday",
  "ThisWeek",
  "Last7Days",
  "Next7Days",
  "Last14Days",
  "Last30Days",
  "ThisMonth",
  "ThisQuarter",
  "NextQuarter",
  "ThisYear",
  "Crossed"
]);

export function resolveOrExecuteRelativeValue({
  LHS,
  RHS,
  fieldType,
  operator
}) {
  let date = new Date();
  let finalRHS = RHS;
  switch (RHS) {
    case "Today": {
      finalRHS = formatDateToUserDate(date);
      let finalLHS = LHS;
      if (fieldType === "DateTime") {
        finalLHS =
          LHS && formatDateToUserDate(new Date(formatDateTime(LHS, "ISO")));
      }
      return DateClass[operator](finalLHS, finalRHS);
    }
    case "Yesterday": {
      date.setDate(date.getDate() - 1);
      finalRHS = formatDateToUserDate(date);
      let finalLHS = LHS;
      if (fieldType === "DateTime") {
        finalLHS =
          LHS && formatDateToUserDate(new Date(formatDateTime(LHS, "ISO")));
      }
      return DateClass[operator](finalLHS, finalRHS);
    }
    case "Tomorrow": {
      date.setDate(date.getDate() + 1);
      finalRHS = formatDateToUserDate(date);
      let finalLHS = LHS;
      if (fieldType === "DateTime") {
        finalLHS =
          LHS && formatDateToUserDate(new Date(formatDateTime(LHS, "ISO")));
      }
      return DateClass[operator](finalLHS, finalRHS);
    }
    case "Now": {
      if (!LHS) return false;
      let finrhs = "";
      if (fieldType === "Date") {
        finrhs = formatDateToUserDate(new Date());
      } else {
        finrhs = formatDateToUserDate(new Date(), true);
      }
      let cl = fieldType === "Date" ? DateClass : DateTimeClass;
      return cl[operator](LHS, finrhs);
    }
    case "Next6Hours": {
      if (!LHS) return false;
      let fromdatetime = formatDateToUserDate(new Date(), true);
      let todatetime = formatDateToUserDate(
        new Date(date.setHours(date.getHours() + 6)),
        true
      );
      return DateTimeClass.BETWEEN(LHS, [fromdatetime, todatetime]);
    }
    case "Next12Hours": {
      if (!LHS) return false;
      let fromdatetime = formatDateToUserDate(new Date(), true);
      let todatetime = formatDateToUserDate(
        new Date(date.setHours(date.getHours() + 12)),
        true
      );
      return DateTimeClass.BETWEEN(LHS, [fromdatetime, todatetime]);
    }
    case "ThisWeek": {
      let fromdate = new Date();
      let from = formatDateToUserDate(
        new Date(fromdate.setDate(fromdate.getDate() - fromdate.getDay())),
        fieldType === "DateTime"
      );
      let todate = new Date();
      let to = formatDateToUserDate(
        new Date(todate.setDate(todate.getDate() + (6 - todate.getDay()))),
        fieldType === "DateTime"
      );
      let cl = fieldType === "Date" ? DateClass : DateTimeClass;
      return cl.BETWEEN(LHS, [from, to]);
    }
    case "Last7Days": {
      let fromdate = new Date();
      let from = formatDateToUserDate(
        new Date(fromdate.setDate(fromdate.getDate() - 7)),
        fieldType === "DateTime"
      );
      let todate = new Date();
      let to = formatDateToUserDate(todate, fieldType === "DateTime");
      let cl = fieldType === "Date" ? DateClass : DateTimeClass;
      return cl.BETWEEN(LHS, [from, to]);
    }
    case "Next7Days": {
      let fromdate = new Date();
      let from = formatDateToUserDate(fromdate, fieldType === "DateTime");
      let todate = new Date();
      let to = formatDateToUserDate(
        new Date(todate.setDate(todate.getDate() + 7)),
        fieldType === "DateTime"
      );
      let cl = fieldType === "Date" ? DateClass : DateTimeClass;
      return cl.BETWEEN(LHS, [from, to]);
    }
    case "Last14Days": {
      let fromdate = new Date();
      let from = formatDateToUserDate(
        new Date(fromdate.setDate(fromdate.getDate() - 14)),
        fieldType === "DateTime"
      );
      let todate = new Date();
      let to = formatDateToUserDate(todate, fieldType === "DateTime");
      let cl = fieldType === "Date" ? DateClass : DateTimeClass;
      return cl.BETWEEN(LHS, [from, to]);
    }
    case "Last30Days": {
      let fromdate = new Date();
      let from = formatDateToUserDate(
        new Date(fromdate.setDate(fromdate.getDate() - 30)),
        fieldType === "DateTime"
      );
      let todate = new Date();
      let to = formatDateToUserDate(todate, fieldType === "DateTime");
      let cl = fieldType === "Date" ? DateClass : DateTimeClass;
      return cl.BETWEEN(LHS, [from, to]);
    }
    case "ThisMonth": {
      if (!LHS) return false;
      let newdate = new Date();
      let actualdate = "";
      if (fieldType === "DateTime")
        actualdate = new Date(formatDateTime(LHS, "ISO"));
      else actualdate = new Date(LHS);
      return (
        newdate.getFullYear() === actualdate.getFullYear() &&
        newdate.getMonth() === actualdate.getMonth()
      );
    }
    case "ThisYear": {
      if (!LHS) return false;
      let newdate = new Date();
      let actualdate = "";
      if (fieldType === "DateTime")
        actualdate = new Date(formatDateTime(LHS, "ISO"));
      else actualdate = new Date(LHS);
      console.log(actualdate);
      console.log(newdate);
      return newdate.getFullYear() === actualdate.getFullYear();
    }
    case "ThisQuarter": {
      if (!LHS) return false;
      let actualdate = "";
      if (fieldType === "DateTime")
        actualdate = new Date(formatDateTime(LHS, "ISO"));
      else actualdate = new Date(LHS);
      let todate = date;
      return (
        actualdate.getFullYear() === todate.getFullYear() &&
        getQaurter(actualdate) === getQaurter(todate)
      );
    }
    case "NextQuarter": {
      if (!LHS) return false;
      let actualdate = "";
      if (fieldType === "DateTime")
        actualdate = new Date(formatDateTime(LHS, "ISO"));
      else actualdate = new Date(LHS);
      let todate = date;
      if (
        actualdate.getFullYear() === todate.getFullYear() &&
        getQaurter(date) + 1 < 5 &&
        getQaurter(actualdate) === getQaurter(date) + 1
      ) {
        return true;
      }
      if (
        actualdate.getFullYear() === todate.getFullYear() + 1 &&
        getQaurter(date) === 4 &&
        getQaurter(actualdate) === 1
      ) {
        return true;
      }
      return false;
    }
    case "Crossed": {
      if (!LHS) return false;
      return dueDateOverDue(LHS);
    }
    default:
      break;
  }
}

export function getSelectedItemsInCheckList(list) {
  let cum = 0;
  for (let item of list) {
    if (item.selected) cum += 1;
  }
  return cum;
}

export function getCurrencyValue(currencystr) {
  return currencystr && parseInt(currencystr.split(" ")[0], 10);
}

export function isSameCurrencyUnit(lhs, rhs) {
  return lhs && lhs.split(" ")[1] === rhs.split(" ")[1];
}

function getQaurter(date) {
  let month = date.getMonth() + 1;
  return Math.ceil(month / 3);
}

// function getDateString(date) {
//   let month =
//     date.getMonth() < 9 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
//   let day = date.getDate() < 9 ? `0${date.getDate()}` : date.getDate();
//   return `${date.getFullYear()}-${month}-${day}`;
// }
